<div class="profiles-wrap" [class.profiles-wrap--section]="showSectionHeader" *ngIf="cachedProfiles?.length > 0">
  <div class="profiles-section-head" *ngIf="showSectionHeader">
    <span class="profiles-section-title">{{ sectionTitle }}</span>
  </div>

  <ion-list class="profile-list" lines="none">
    <ng-container *ngFor="let profile of cachedProfiles; let i = index">
      <ion-item class="profile-item" detail="false" lines="none" (click)="selectProfile(profile, $event)">
        <ion-avatar slot="start" class="profile-avatar">
          <img *ngIf="profile.foto && !profile._fotoError" [src]="profile.foto"
            (error)="profile._fotoError = true" alt="" />
          <div class="profile-avatar-fallback" *ngIf="!profile.foto || profile._fotoError">
            <ion-icon name="person"></ion-icon>
          </div>
        </ion-avatar>
        <ion-label class="profile-label">
          <h2>{{ profile.naam }}</h2>
          <p>{{ profile.username }}</p>
        </ion-label>
        <ion-icon name="swap-horizontal-outline" class="profile-switch"></ion-icon>
        <ion-button slot="end" fill="clear" class="profile-menu-btn"
          [id]="menuTriggerId(i)"
          (click)="onMenuButtonClick($event)"
          aria-label="Meer opties">
          <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
        </ion-button>
      </ion-item>

      <ion-popover [trigger]="menuTriggerId(i)" triggerAction="click"
        [dismissOnSelect]="true" side="bottom" alignment="end">
        <ng-template>
          <ion-list lines="none">
            <ion-item button detail="false" (click)="confirmDelete(profile)">
              <ion-icon slot="start" name="trash-outline" color="danger"></ion-icon>
              <ion-label color="danger">Profiel verwijderen</ion-label>
            </ion-item>
          </ion-list>
        </ng-template>
      </ion-popover>
    </ng-container>
  </ion-list>
</div>
